module.exports = __webpack_public_path__ + "img/sidebar-icon-subproject.de94ffe2.svg";